<div id="orderresult" class="ya-typography">
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <ng-container *ngIf="checkoutpaymentmodel">
      <ng-container [ngSwitch]="checkoutpaymentmodel.done">
        <ng-container *ngSwitchCase="ResponseCode_Done.Authorised">
          <div class="inline-icon margin-down" inlineSVG="hypersoft-bestellen-bestaetigung2.svg"></div>
          <div class="title margin-down" langkey="phOrderResult_ThankYouForYourOrder"></div>
          <ng-container *ngIf="mail && mail.length > 0">
            <div class="text margin-down" [innerHTML]="confirmationmailtext"></div>
          </ng-container>
          <!-- delivery or takeaway -->
          <ng-container *ngIf="!(service === webShopMode.Webvoucher && voucherservice !== voucherserviceType.Order)">
            <ng-container
              *ngIf="showOrderName">
              <div class="hero-text margin-down" langkey="phOrderResult_Success_YourOrder"></div>
              <div class="hero-text margin-down"><span
                  class="emphasized hero-name">{{checkoutpaymentmodel.table_name}}</span>
              </div>
            </ng-container>
          </ng-container>
          <!-- retail-->
          <ng-container *ngIf="(service === webShopMode.Retail)">
            <ng-container *ngIf="checkoutpaymentmodel && checkoutpaymentmodel.order_id">
              <div class="hero-text margin-down" langkey="phOrderResult_Success_YourOrder"></div>
              <div class="hero-text margin-down">
                <span class="emphasized hero-name">Nr. {{checkoutpaymentmodel.order_id}}</span>
              </div>
              <div class="hero-text margin-down" langkey="phOrderResult_Success_Retail_WillBePackaged_TEXT"></div>
            </ng-container>
          </ng-container>
          <!-- orderresult text for delivery and takeaway-->
          <ng-container *ngIf="ordersuccesstext">
            <div class="text margin-down" [innerHTML]="ordersuccesstext"></div>
          </ng-container>
          <!-- ticket-->
          <ng-container *ngIf="tickets.length > 0">
            <div class="text margin-down" langkey="phOrderResult_SuccessTicket_DownloadText"></div>
            <ng-container *ngIf="mail && mail.length > 0">
              <div class="text margin-down" [innerHTML]="voucherconfirmationmailSend"></div>
            </ng-container>
            <div class="item-list_title" langkey="phOrderResult_SuccessTicket_TitleTicket"></div>
            <div class="item-list">
              <ng-container *ngFor="let ticket of tickets">
                <div class="item ticket">
                  <div class="label">{{ticket.label}}</div>
                  <div class="nr">{{ticket.nr}}</div>
                  <ng-container *ngIf="ticket.valid_date_start_ymd!==0">
                    <div class="date">{{formatDate(ticket.valid_date_start_ymd)}}</div>
                  </ng-container>
                  <div class="ya-webshop-button-container" *ngIf="ticket.isActive && ticket.walletReferenceId">
                    <div class="wallet-buttons">
                      <button mat-button (click)="addToWallet(ticket.walletReferenceId, 'Ticket', 'Apple')">
                        <img src="assets/core/svg/add_to_apple_wallet.svg" alt="Add to Apple Wallet">
                      </button>
                      <button mat-button (click)="addToWallet(ticket.walletReferenceId, 'Ticket', 'Google')">
                        <img src="assets/core/svg/add_to_google_wallet.svg" alt="Add to Google Wallet">
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="loadTicketPDF()">
                <span langkey="phOrderResult_SuccessTicket_ButtonLink"></span>
              </button>
            </div>
          </ng-container>
          <!-- web voucher-->
          <ng-container *ngIf="webvouchers.length > 0">
            <ng-container *ngIf="isWebVoucherMailDelivery">
              <div class="text margin-down" langkey="phOrderResult_SuccessWebvoucher_DownloadText"></div>
              <ng-container *ngIf="mail && mail.length > 0">
                <div class="text margin-down" [innerHTML]="voucherconfirmationmailSend"></div>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="!isWebVoucherMailDelivery">
              <div class="text margin-down" langkey="phOrderResult_SuccessWebvoucher_ConfirmationPostSend"></div>
            </ng-container>
            <div class="webvoucher-list">
              <div class="webVoucher-list__header">
                <h2 langkey="phOrderResult_WebVoucherOrderList_header"></h2>
              </div>
              <div class="webvoucher-list__content">
                <div class="webvoucher-list__content-title">
                  <span class="linkvoucher" langkey="phOrderResult_SuccessWebvoucher_TitleVoucher"></span>
                  <span class='linkvoucher' langkey="phOrderResult_SuccessWebvoucher_TitleAmount"></span>
                </div>
                <div class="webvoucher-list__content-detail">
                  <ng-container *ngFor="let webvoucher of webvouchers">
                    <div class="header-detail">
                      <div class="label">
                        <span>{{webvoucher.label}}</span>
                      </div>
                      <div class="header-detail--wrapper">
                        <ng-container *ngIf="displayWebVoucherPerson(webvoucher.personCount)">
                          <span>{{webvoucher.personCount}}</span>
                          <span class="person-count__label"
                            langkey="phOrderResult_SuccessWebvoucher_Person_Count"></span>
                        </ng-container>
                        <span class="price">{{webvoucher.formattedPrice}}</span>
                      </div>
                    </div>
                    <div class="sub-detail">
                      <span class="number">{{webvoucher.nr}}</span>
                      <span class="delivery" [langkey]="webvoucher.delivery===0?'phOrderResult_SuccessWebvoucher_Person_Mail_Delivery':
                      'phOrderResult_SuccessWebvoucher_Person_Post_Delivery'"></span>
                    </div>
                    <div class="ya-webshop-button-container"
                      *ngIf="webvoucher.isActive && webvoucher.walletReferenceId">
                      <div class="wallet-buttons">
                        <button mat-button (click)="addToWallet(webvoucher.walletReferenceId, 'Voucher', 'Apple')">
                          <img src="assets/core/svg/add_to_apple_wallet.svg" alt="Add to Apple Wallet">
                        </button>
                        <button mat-button (click)="addToWallet(webvoucher.walletReferenceId, 'Voucher', 'Google')">
                          <img src="assets/core/svg/add_to_google_wallet.svg" alt="Add to Google Wallet">
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <ng-container *ngIf="isWebVoucherMailDelivery">
              <div class="ya-webshop-button-container">
                <button mat-flat-button (click)="loadVoucherPDF()">
                  <span langkey="phOrderResult_SuccessWebvoucher_ButtonLink"></span>
                </button>
              </div>
            </ng-container>
          </ng-container>
          <!-- voucher charge-->
          <ng-container *ngIf="service === webShopMode.Webvoucher && voucherservice !== voucherserviceType.Order">
            <div class="text margin-down" langkey="phOrderResult_VoucherCredit_Charge"></div>
          </ng-container>
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="showReturnToHomeBtn">
              <button mat-flat-button (click)="gotoHome()">
                <span langkey="phOrderResult_ToTheHomescreen"></span>
              </button>
            </ng-container>
            <ng-container *ngIf="showReturnToURLBtn">
              <a [href]="returnURL" target="_self">
                <button mat-flat-button>
                  <span langkey="phGlobal_Return"></span>
                </button>
              </a>
            </ng-container>
          </div>
          <ng-container *ngIf="service !== webShopMode.OrderToTable && phonenumber && phonenumber.length > 0">
            <div class="text" langkey="phOrderResult_PhoneNumberForCallback"></div>
            <ng-container *ngIf="isMobile; else desktopView">
              <a [href]="'tel:' + phonenumber" class="phonenumberclick margin-down">{{phonenumber}}</a>
            </ng-container>
            <ng-template #desktopView>
              <div class="phonenumber margin-down">{{ phonenumber }}</div>
            </ng-template>
          </ng-container>
          <ng-container *ngFor="let bonus of bonuspointsHTMLs">
            <div class="bonuspoints" [innerHTML]="bonus"></div>
          </ng-container>
          <ng-container *ngIf="showCustomLandingPageBtn">
            <div class="ya-webshop-button-container">
              <button mat-flat-button (click)="clickCustomLandingPage()">
                <span>{{customLandingPageBtnText}}</span>
              </button>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Cancelled">
          <div class="title margin-down" langkey="phOrderResult_YourOrderWasCancelled"></div>
          <div class="text margin-down" langkey="phOrderResult_DoYouWantToContinue_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToCheckout()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Error">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Refused">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-template #Error>
          <div class="title margin-down" langkey="phOrderResult_OrderCouldNotBeAccepted"></div>
          <div class="text margin-down" langkey="phOrderResult_ThereWasAProblem_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToCheckout()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>